import React, { useState,useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames';
import { useQuery } from '@apollo/react-hooks';

import { Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

import { ACCOMMODATIONS_WITH_BOOKINGS} from 'graphql/queries/accommodations';

import { AppHeader, CircularLoader } from 'components';

import CalendarGeneralRow from './components/calendar-general-row/CalendarGeneralRow';
import OverviewCalendarHeader from './components/overview-calendar-header/OverviewCalendarHeader';
import BookingsDetailsDialog from 'components/booking-details-dialog/BookingDetailsDialog';

import { getRangeList } from 'utils/datesMethods';
import {
  getAccommodationBookingTotalInfo,
  getCalendarAccommodationsBookings,
  guestsSumSeats
} from 'utils/bookings/prepareBookingsData';

import useStyles from './styles';


const ACCOMMODATION_TAB_INDEX = 0;

const isAccommodationUnActive = (booking, day) => {
  const bookingFromDate =
    booking.fromDate && moment(booking.fromDate, 'YYYY-MM-DD');
  const bookingEndDate = booking.toDate && moment(booking.toDate, 'YYYY-MM-DD');
  if (bookingFromDate && bookingEndDate) {
    return !moment(day.date).isBetween(
      bookingFromDate,
      bookingEndDate,
      'day',
      '[]'
    );
  }
  if (bookingFromDate) {
    return !moment(day.date).isSameOrAfter(bookingFromDate, 'day');
  }
  if (bookingEndDate) {
    return !moment(day.date).isSameOrBefore(bookingEndDate, 'day');
  }
  return true;
};

const BookingsList = ({ accommodationsBookings, rangeList, refetch  }) => {
  const classes = useStyles();
  const history = useHistory();  
 
  if (!accommodationsBookings || !accommodationsBookings.length) return null;
  return (
    <div className={classes.bookingsList}>
      {accommodationsBookings.map((booking) => {
        return (
          <div
            key={booking.id}
            className={classNames(
              classes.bookingRow,
              classes.bookingAccommodationTitleBgWrapper
            )}
          >
            <div className={classes.bookingTitleBlock}>
            <Tooltip title={`${booking?.productCode} . ${booking?.title}`} arrow>
                      <Typography
                        variant="body1"
                        className={classes.bookingTitle}
                        onClick={() => {
                          history.push(`/accommodations/${booking.id}`);
                        }}
                      >
                        
                          <img
                            src={booking?.photo }
                            alt="Booking Icon"
                            className={classes.bookingImage}
                          />
                      
                      
                        <span variant="body1" className={classes.wrapperTitle}>
                          <span className={classes.bookingTitleText}>{booking?.title}</span>
                          <span className={classes.bookingProductCode}>
                            {booking?.productCode}
                          </span>
                        </span>
                      </Typography>
              </Tooltip>

            </div>
            <BookingsDatesList
              booking={booking}
              rangeList={rangeList}
              refetch={refetch}
            />
          </div>
        );
      })}
    </div>
  );
};

const DatesListWithoutBookings = ({ rangeList, booking }) => {
  const classes = useStyles();
  let isInit = true;
  let isProgress = false;

  return (
    <div className={classes.columnWrapper}>
      {rangeList.map((item, index) => {
        const isUnActive = isAccommodationUnActive(booking, item);
        const previousItem = rangeList[index - 1];
        const isUnActivePreviousItem = previousItem
          ? isAccommodationUnActive(booking, previousItem)
          : false;
        const nextItem = rangeList[index + 1];
        const isUnActiveNextItem = nextItem
          ? isAccommodationUnActive(booking, nextItem)
          : true;

        const isStart = isInit && isUnActive && isUnActiveNextItem;
        const isMid =
          isProgress &&
          !isStart &&
          isUnActiveNextItem &&
          index &&
          index < rangeList.length - 1;
        const isEnd =
          isProgress && !isStart && !isMid && isUnActivePreviousItem;

        if (isUnActive) {
          isInit = false;
          isProgress = true;
        }

        return (
          <div
            key={index}
            className={classNames(classes.column, classes.participantsColumn)}
          >
            <Typography
              variant="body1"
              className={classNames(
                classes.noParticipants,
                { [classes.participantsStart]: isStart },
                {
                  [classes.participantsMid]: isMid
                },
                { [classes.participantsEnd]: isEnd },
                { [classes.activeProduct]: !isUnActive }
              )}
            >
              {' '}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

const BookingsDatesList = ({ booking, rangeList, refetch }) => {
  const classes = useStyles();
  
  const accommodations = booking.accommodations;
  const [open, setOpen] = React.useState(false);
  const [dialogContent, setDialogContent] = React.useState({});
  const [participantColors, setParticipantColors] = React.useState({}); 
  const onClose = () => {
    setOpen(false);
    refetch();
  };

  useEffect(() => {
    if (accommodations) {
      const newParticipantColors = {};
      accommodations.forEach(accommodation => {
        newParticipantColors[accommodation.id] = accommodation.color;
      });
      setParticipantColors(newParticipantColors);
    }
  }, [accommodations]);
  
  if (!accommodations) {
    return <DatesListWithoutBookings rangeList={rangeList} booking={booking} />;
  }

  return (
    <div className={classes.columnWrapper}>
      {rangeList.map((item, index) => {
        const lastIndex = rangeList.length - 1;

        const isUnActive = isAccommodationUnActive(booking, item);
        const previousItem = rangeList[index - 1];
        const isUnActivePreviousItem = previousItem
          ? isAccommodationUnActive(booking, previousItem)
          : false;
        const nextItem = rangeList[index + 1];
        const isUnActiveNextItem = nextItem
          ? isAccommodationUnActive(booking, nextItem)
          : true;

        const isStartDate = accommodations.find(accommodation => {
          return moment(accommodation.fromDate, 'YYYY-MM-DD').isSame(
            item.date,
            'day'
          );
        });
        const isEndDate = accommodations.find(accommodation => {
          return moment(accommodation.toDate, 'YYYY-MM-DD').isSame(
            item.date,
            'day'
          );
        });
        const isMidDate =
          !isStartDate &&
          !isEndDate &&
          accommodations.find(accommodation => {
            const fromDate = moment(accommodation.fromDate, 'YYYY-MM-DD');
            const toDate = moment(accommodation.toDate, 'YYYY-MM-DD');
            return moment(item.date).isBetween(fromDate, toDate, 'day', '[]');
          });
        const isHalfDate = isStartDate && isEndDate;
        const accommodation = isStartDate || isMidDate || isEndDate;

        const isNextDayStart =
          !accommodation &&
          rangeList[index + 1] &&
          accommodations.find(accommodation => {
            return moment(accommodation.fromDate, 'YYYY-MM-DD').isSame(
              rangeList[index + 1].date,
              'day'
            );
          });

        const isPreviousDayEnd =
          !accommodation &&
          rangeList[index - 1] &&
          accommodations.find(accommodation => {
            return moment(accommodation.toDate, 'YYYY-MM-DD').isSame(
              rangeList[index - 1].date,
              'day'
            );
          });

        const openDialog = accommodation => {
          setOpen(true);
          setDialogContent({
            ...accommodation,
            id: accommodation.id
          });
        }; 

        const getTextColor = (bgColor) => {
          if (!bgColor) return "#FFF"; 

          const r = parseInt(bgColor.substring(1, 3), 16);
          const g = parseInt(bgColor.substring(3, 5), 16);
          const b = parseInt(bgColor.substring(5, 7), 16);


          const brightness = (r * 299 + g * 587 + b * 114) / 1000;

          return brightness > 125 ? "#000" : "#FFF"; 
        };

        const participantColor = accommodation ? participantColors[accommodation.id] : null;
        const textColor = getTextColor(participantColor);

        
        return (
          <div
            key={index}
            className={classNames(classes.column, classes.participantsColumn)}
          >
            {isStartDate || isMidDate || isEndDate ? (
              <Typography
                variant="body1"
                onClick={() => openDialog(accommodation)}
                className={classNames(
                  classes.participants,
                  classes.participantsHover,
                  {
                    [classes.participantsHalfStart]: isStartDate && !isHalfDate
                  },
                  { [classes.participantsHalfDate]: isHalfDate },
                  { [classes.participantsMid]: isMidDate },
                  { [classes.participantsHalfEnd]: isEndDate && !isHalfDate }
                )}
                style={{ backgroundColor: participantColor }} 
              >
              {(isStartDate || !index) && (
                <span
                className={classNames(
                  classes.guestName
                )}
                style={{ color: textColor }} 
                >
                  {`${guestsSumSeats(accommodation.guests)}/${
                    accommodation.guestsNumber
                  }`} 
                <br/>
                      { accommodation.guestFirstName +  ' ' + accommodation.guestLastName}
                 </span>
                    
              )}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                className={classNames(
                  classes.noParticipants,
                  {
                    [classes.participantsStart]:
                      (!isUnActivePreviousItem &&
                        isUnActiveNextItem &&
                        index !== lastIndex &&
                        !isNextDayStart) ||
                      (isUnActiveNextItem &&
                        (!isNextDayStart || !isPreviousDayEnd) &&
                        ((isPreviousDayEnd && index !== lastIndex) ||
                          (!isNextDayStart && !index)))
                  },
                  {
                    [classes.participantsMid]:
                      isUnActivePreviousItem &&
                      isUnActiveNextItem &&
                      !isPreviousDayEnd &&
                      !isNextDayStart &&
                      index &&
                      index !== lastIndex
                  },
                  {
                    [classes.participantsEnd]:
                      (!isUnActiveNextItem &&
                        isUnActivePreviousItem &&
                        !isPreviousDayEnd) ||
                      (isUnActivePreviousItem &&
                        (!isNextDayStart || !isPreviousDayEnd) &&
                        ((isNextDayStart && index) ||
                          (!isPreviousDayEnd && index === lastIndex)))
                  },
                  { [classes.activeProduct]: !isUnActive }
                )}
              >
                {' '}
              </Typography>
            )}
          </div>
        );
      })}
      <BookingsDetailsDialog
        isEditCancelBtns={true}
        onClose={onClose}
        open={open}
        booking={dialogContent}
        bookingTotal={getAccommodationBookingTotalInfo(dialogContent)}
        refetchParams={{ query: ACCOMMODATIONS_WITH_BOOKINGS }}
        cancelBooking={() => {
          refetch();
          setOpen(false);
        }}
      />
    </div>
  );
};

const AccommodationsOverviewCalendar = ({ businessOwner }) => {
  const classes = useStyles();

  const [rangeDates, setRangeDates] = React.useState({
    startDate: moment().startOf('isoWeek'),
    endDate: moment().endOf('isoWeek')
  });
  const [accommodationsBookings, setAccommodationsBookings] = React.useState(
    null
  );
  const [rangeList, setRangeList] = React.useState(
    getRangeList(rangeDates.startDate, rangeDates.endDate)
  );
  const [selectedDate, setSelectedDate] = useState(null);

  const { loading, data, refetch } = useQuery(ACCOMMODATIONS_WITH_BOOKINGS, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      startPeriod: moment(rangeDates.startDate).format('YYYY-MM-DD'),
      endPeriod: moment(rangeDates.endDate).format('YYYY-MM-DD'),
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    }
  });

  React.useEffect(() => {
    if (!data) return;

    setRangeList(getRangeList(rangeDates.startDate, rangeDates.endDate));
    setAccommodationsBookings(
      getCalendarAccommodationsBookings(data.accommodations)
    );
  }, [data]);

  const changeWeek = range => {
    setRangeDates(range);
  };

  return (
    <div className={classes.wrapper}>
      <AppHeader />

      <CircularLoader
        isLoading={loading}
        loaderClassName={classes.loaderClassName}
        className={classes.loaderWrapper}
      />

      <OverviewCalendarHeader
        startDate={rangeDates.startDate}
        endDate={rangeDates.endDate}
        changeWeekCallback={changeWeek}
        tabIndex={ACCOMMODATION_TAB_INDEX}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
      />

      <div className={classes.calendarWrapper}>
        <CalendarGeneralRow
          rangeList={rangeList}
          title="Accommodations"
          selectedDate={selectedDate}
        />

        <BookingsList
          accommodationsBookings={accommodationsBookings}
          rangeList={rangeList}
          refetch={refetch}
          accommodation={data?.accommodations?.[0]} 
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(AccommodationsOverviewCalendar);


